<template>
  <div
    v-if="form"
  >
    <!-- Media -->
    <b-media class="mb-2">
      <template #aside>
        <b-avatar
          ref="previewEl"
          :src="form.govImgURL"
          :text="avatarText('qrcode')"
          variant="light-primary"
          size="100px"
          rounded
        />
      </template>
      <h4 class="mb-1">
        簡訊實聯制
      </h4>
      <div class="d-flex flex-wrap">
        <b-button
          variant="primary"
          @click="qrcodeUpload = !qrcodeUpload"
        >
          <span class="d-none d-sm-inline">更換</span>
          <feather-icon
            icon="EditIcon"
            class="d-inline d-sm-none"
          />
        </b-button>
        <b-button
          v-if="form.govImgURL != ''"
          variant="outline-secondary"
          class="ml-1"
          @click="removeLogoImg"
        >
          <span class="d-none d-sm-inline">移除</span>
          <feather-icon
            icon="TrashIcon"
            class="d-inline d-sm-none"
          />
        </b-button>
        <my-upload
          v-model="qrcodeUpload"
          lang-type="zh-tw"
          field="img"
          img-format="png"
          @crop-success="cropSuccess"
        />
      </div>
    </b-media>

    <!-- Action Buttons -->
    <b-button
      variant="primary"
      class="mb-1 mb-sm-0 mr-0 mr-sm-1"
      :block="$store.getters['app/currentBreakPoint'] === 'xs'"
      :disabled="btnDisable"
      @click="saveChanges"
    >
      <div v-if="submit">
        <b-spinner small />
        <span class="sr-only">更新中...</span>
      </div>
      <div v-else-if="!success">
        儲存變更
      </div>
      <div v-else-if="success">
        已儲存
      </div>
    </b-button>
    <b-button
      v-if="btnReset"
      variant="outline-secondary"
      :block="$store.getters['app/currentBreakPoint'] === 'xs'"
      @click="setDefault"
    >
      取消
    </b-button>
    <div
      class="pt-1"
    >
      <span>申請政府簡訊實聯制 Qrcode <b-link
        href="https://emask.taiwan.gov.tw/real"
        target="_blank"
      >這邊申請</b-link></span>
    </div>
    <div>
      <span>如何從 PDF 中下載 Qrcode？<b-link
        href="https://pdfcandy.com/extract-images.html"
        target="_blank"
      >使用此網站</b-link></span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  BButton, BMedia, BAvatar, BSpinner, BLink,
} from 'bootstrap-vue'
import store from '@/store'
import { avatarText } from '@core/utils/filter'
import myUpload from 'vue-image-crop-upload/upload-2.vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BLink,
    BButton,
    BSpinner,
    BMedia,
    BAvatar,
    myUpload,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      statusOptions: ['delete', 'suspanded'],
      avatarText,
      form: null,
      qrcodeUpload: false,
      needUpload: false,
      btnDisable: true,
      success: false,
      update: false,
      submit: false,
    }
  },
  computed: {
    ...mapGetters(['campaign']),
  },
  mounted() {
    this.setDefault()
  },
  methods: {
    setDefault() {
      this.form = {
        govImgURL: this.campaign.govImgURL,
      }
      this.needUpload = false
      this.btnDisable = true
      this.btnReset = false
      this.success = false
      this.update = false
      this.submit = false
    },
    cropSuccess(imgDataUrl) {
      this.success = false
      this.form.govImgURL = imgDataUrl
      this.needUpload = true
      this.btnDisable = false
      this.btnReset = true
    },
    removeLogoImg() {
      this.success = false
      this.form.govImgURL = ''
      this.needUpload = true
      this.btnDisable = false
      this.btnReset = true
    },
    saveChanges() {
      this.submit = true
      this.btnDisable = true

      if (this.needUpload) {
        store.dispatch('uploadCampaignImage', {
          type: 'data_url',
          data: this.form.govImgURL,
          uid: this.campaign.cuid,
          cid: this.campaign.cid,
          colName: 'govImgURL',
          name: `${this.campaign.cid}-govqrcode`,
        }).then(() => {
          if (!this.update) {
            this.success = true
            this.submit = false
          }
        }).catch(() => {
          if (!this.update) {
            this.success = false
            this.submit = false
          }
        })
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
